export default {"src":"/_next/static/media/check.5bd4c0c7.svg","height":12,"width":16};